import { Popup } from 'semantic-ui-react';
import ButtonWrapper from '@components/common/ButtonWrapper';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

type Props = {
  actions: any;
  selectedRows: any;
};

const MarkInetoryCheckedPopup = ({ actions, selectedRows }: Props) => {
  const { t } = useTranslation();
  const onClick = () => {
    const exportIds = Object.keys(selectedRows);
    if (exportIds.length > 0) {
      actions.markAsChecked(exportIds);
    } else {
      (toast as any).warning(t('message.title.warning.export.no.selected.rows'));
    }
  };

  return (
    <Popup
      trigger={
        <ButtonWrapper
          label={t('inventory.overview.page.mark.inventory.checked')}
          icon="check"
          type="button"
          onClick={() => {
            onClick();
          }}
        />
      }
      size="mini"
      position="bottom right"
      content={t('inventory.overview.page.mark.inventory.checked.info')}
    />
  );
};

export default MarkInetoryCheckedPopup;
